// Search items handle
(() => {
  const applyProductHandles = () => {
    const products = document.querySelectorAll('.usf-is__product');
    
    if (products.length === 0) return;
    
    products.forEach((product) => {
      const vueInstance = product.__vue__;
      
      if (vueInstance && vueInstance.product) {
        const handle = vueInstance.product.urlName;
        const priceWrapper = product.querySelector('.usf-price-wrapper');
        
        if (priceWrapper && handle && !priceWrapper.hasAttribute('data-product-handle')) {
          priceWrapper.setAttribute('data-product-handle', handle);
        }
      }
    });
    
    if (window.Abra && window.Abra.render) window.Abra.render();
  };

  const observer = new MutationObserver(applyProductHandles);
  
  observer.observe(document.body, { 
    childList: true, 
    subtree: true
  });

  setInterval(applyProductHandles, 500);
})();

// Rebuy pdp products handle
(() => {
  const applyRebuyProductHandles = () => {
    const items = document.querySelectorAll('.rebuy-addon__item');
    
    if (items.length === 0) return;
    
    items.forEach((item) => {
      const link = item.querySelector('.rebuy-addon__item-link');
      const priceWrapper = item.querySelector('.rebuy-addon__item-product-price');
      
      if (link && priceWrapper) {
        const href = link.getAttribute('href');
        
        if (href && href.includes('/products/')) {
          const handle = href.split('/products/')[1].split('?')[0];
          
          if (handle && !priceWrapper.hasAttribute('data-product-handle')) {
            priceWrapper.setAttribute('data-product-handle', handle);
          }
        }
      }
    });
    
    if (window.Abra && window.Abra.render) {
      window.Abra.render();
    }
  };

  const observer = new MutationObserver(() => {
    applyRebuyProductHandles();
  });

  const startObserver = () => {
    const targetNodes = document.querySelectorAll('.rebuy-addon, .rebuy-addon__items');
    
    targetNodes.forEach(node => {
      observer.observe(node, { 
        childList: true, 
        subtree: true
      });
    });
  };

  const checkAndStart = setInterval(() => {
    const addon = document.querySelector('.rebuy-addon');
    if (addon) {
      clearInterval(checkAndStart);
      startObserver();
      applyRebuyProductHandles();
    }
  }, 100);

  setTimeout(() => {
    clearInterval(checkAndStart);
  }, 10000);
})();

// Render abra for Rebuy product section
(() => {
  const triggerAbraOnRebuy = () => {
    if (window.Abra && window.Abra.render) {
      window.Abra.render();
    }
  };

  const observer = new MutationObserver(triggerAbraOnRebuy);
  
  const targetNode = document.querySelector('.rebuy-widget-content, .rebuy-product-grid');
  if (targetNode) {
    observer.observe(targetNode, { childList: true, subtree: true });
  }

  const checkAndObserve = setInterval(() => {
    const rebuyWidget = document.querySelector('.rebuy-widget-content, .rebuy-product-grid');
    if (rebuyWidget) {
      clearInterval(checkAndObserve);
      observer.observe(rebuyWidget, { childList: true, subtree: true });
      triggerAbraOnRebuy();
    }
  }, 100);

  setTimeout(() => clearInterval(checkAndObserve), 1000);
})();

// Cart Page Events
(() => {
  const dispatchCartItemChanged = (response = null) => {
    const event = new CustomEvent('cartItemChanged', {
      detail: {
       response: response,
       timestamp: Date.now()
       }
      });
      document.dispatchEvent(event);
    };

    document.addEventListener('refreshCartItems', () => {
      window.location.reload();
    });

    if (window.location.pathname === '/cart') {
      const cartObserver = new MutationObserver(() => {
        dispatchCartItemChanged();
        if (window.Abra && window.Abra.render) {
          window.Abra.render();
        }
      });

      const startCartObserver = () => {
        const cartItemList = document.querySelector('[data-cart-item-list]');
        if (cartItemList) {
          cartObserver.observe(cartItemList, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['data-cartitem-id']
          });
        }
      };

      setTimeout(startCartObserver, 1000);
    }
})();

// Cart Auto-Refresh
(() => {
  document.addEventListener('refreshCartItems', () => {
    if (window.Abra && window.Abra.render) {
      window.Abra.render();
    }
  });

  if (window.location.pathname === '/cart') {
    const cartChanged = sessionStorage.getItem('cartQuantityChanged');
    if (cartChanged === 'true') {
      sessionStorage.removeItem('cartQuantityChanged');
      
      window.addEventListener('load', () => {
        setTimeout(() => {
          const event = new CustomEvent('refreshCartItems');
          document.dispatchEvent(event);
        }, 2000);
      });
    }
    
    document.addEventListener('change', (e) => {
      if (e.target.matches('[data-cartitem-quantity]')) {
        sessionStorage.setItem('cartQuantityChanged', 'true');
      }
    }, true);
    
    document.addEventListener('click', (e) => {
      const removeBtn = e.target.closest('[data-cartitem-remove]') || 
                       (e.target.hasAttribute && e.target.hasAttribute('data-cartitem-remove'));
      
      if (removeBtn) {
        sessionStorage.setItem('cartQuantityChanged', 'true');
      }
    }, true);
  }
})();